/**
 * product-match-badge.js
 *
 * Injects a match % badge on product pages for wines that were recommended
 * on /collections/my-wine-playlist. Reads match data saved by food-pairing-filter.js
 * into sessionStorage['vinpop_product_matches'].
 *
 * Injects:
 *   1. Terracotta circular badge (% match) on the main product image
 *      — larger on desktop via CSS media query
 *   2. Bilingual match message below the product description block
 */

(function () {
  'use strict';

  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) return;

  // Read match data from sessionStorage
  var matches = {};
  try {
    var stored = sessionStorage.getItem('vinpop_product_matches');
    if (stored) matches = JSON.parse(stored);
  } catch (e) {}

  if (!Object.keys(matches).length) return;

  var isEN = (document.documentElement.lang || '').toLowerCase().startsWith('en');

  // Build a locale-aware match message from structured data
  function buildMessage(data) {
    var score = data.score;
    var isLovedWine = data.isLovedWine;
    var sourceName = data.sourceProductName || '';

    if (isLovedWine) {
      return isEN ? 'You loved this wine' : 'Je hebt deze wijn geweldig gevonden';
    }

    var qualifier;
    if (score >= 95) {
      qualifier = isEN
        ? 'Only professional tasters perceive the difference'
        : 'Alleen professionele proevers merken het verschil';
    } else if (score >= 91) {
      qualifier = isEN
        ? 'Wine connoisseurs also perceive the difference'
        : 'Ook wijnkenners merken het verschil';
    } else if (score >= 85) {
      qualifier = isEN ? 'Very close taste profile' : 'Zeer dicht smaakprofiel';
    } else if (score >= 80) {
      qualifier = isEN ? 'Related wine' : 'Verwante wijn';
    } else {
      qualifier = isEN ? 'Different taste' : 'Andere smaak';
    }

    var because = isEN ? 'because you loved' : 'omdat je vond';
    return score + '% ' + qualifier + (sourceName ? ', ' + because + ' ' + sourceName : '');
  }

  function getProductId() {
    var island = document.querySelector('data-island[data-product-id]');
    return island ? island.getAttribute('data-product-id') : null;
  }

  // Inject responsive badge size CSS once
  function injectBadgeCSS() {
    if (document.getElementById('vinpop-product-badge-css')) return;
    var style = document.createElement('style');
    style.id = 'vinpop-product-badge-css';
    style.textContent = [
      '.vinpop-product-score-badge {',
      '  width: 72px; height: 72px;',
      '  top: 16px; right: 16px;',
      '}',
      '.vinpop-product-score-badge .vinpop-badge-pct { font-size: 22px; }',
      '.vinpop-product-score-badge .vinpop-badge-label { font-size: 10px; }',
      '@media (min-width: 990px) {',
      '  .vinpop-product-score-badge { width: 104px !important; height: 104px !important; top: 20px !important; right: 20px !important; }',
      '  .vinpop-product-score-badge .vinpop-badge-pct { font-size: 32px !important; }',
      '  .vinpop-product-score-badge .vinpop-badge-label { font-size: 13px !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function injectBadgeAndMessage(productId) {
    var data = matches[productId];
    if (!data) return;

    var score = data.score;
    var isLovedWine = data.isLovedWine;

    injectBadgeCSS();

    // ── 1. Badge on main product image ─────────────────────────────────────
    var mediaSection = document.querySelector('.product-media');
    if (mediaSection && score !== null) {
      if (!mediaSection.querySelector('.vinpop-product-score-badge')) {
        mediaSection.style.position = 'relative';

        var badge = document.createElement('div');
        badge.className = 'vinpop-product-score-badge pointer-events-none';
        badge.style.cssText =
          'position:absolute;border-radius:50%;' +
          'background:#E07A5F;color:#fff;display:flex;align-items:center;justify-content:center;' +
          "text-align:center;font-family:'Prompt',sans-serif;" +
          'box-shadow:0 3px 10px rgba(0,0,0,0.18);' +
          'transform:rotate(5deg);' +
          'z-index:30;pointer-events:none;' +
          'border:2px solid rgba(0,0,0,0.15);';

        if (isLovedWine) {
          badge.innerHTML = '<span style="font-size:20px;line-height:1;">❤️</span>';
        } else {
          badge.innerHTML =
            '<div style="line-height:1.05;text-align:center;">' +
              '<span class="vinpop-badge-pct" style="font-weight:900;display:block;">' + score + '%</span>' +
              '<span class="vinpop-badge-label" style="text-transform:uppercase;letter-spacing:0.05em;font-weight:700;">match</span>' +
            '</div>';
        }

        mediaSection.appendChild(badge);
      }
    }

    // ── 2. Bilingual match message below description block ──────────────────
    var descBlock = document.querySelector('.product-block-description');
    if (descBlock) {
      if (!document.querySelector('.vinpop-product-match-message')) {
        var localizedMessage = buildMessage(data);
        var msgDiv = document.createElement('div');
        msgDiv.className = 'vinpop-product-match-message product-block mt-5';
        msgDiv.style.cssText =
          'display:block;font-size:0.85rem;font-weight:600;' +
          'color:rgb(var(--color-scheme-text));line-height:1.3;text-align:center;' +
          'padding:0.6rem 0.75rem;background:rgba(224,122,95,0.08);' +
          'border-radius:10px;border:1px solid rgba(224,122,95,0.2);';
        msgDiv.innerHTML = '<span>❤️</span> ' + localizedMessage;

        descBlock.insertAdjacentElement('afterend', msgDiv);
      }
    }
  }

  function run() {
    var productId = getProductId();
    if (productId) injectBadgeAndMessage(productId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

